<template>
  <div class="app-container flex flex-col min-h-screen" :class="{ 'is-mobile': isMobile }">
    <!-- 电脑端导航 -->
    <pcNav :isMobile="isMobile" :systemInfo="systemInfo" :announcement="announcement" @closeAnnouncement = 'closeAnnouncement' />

    <!-- 移动端导航 -->
    <mobileNav :isMobile="isMobile" :systemInfo="systemInfo" :announcement="announcement" @closeAnnouncement = 'closeAnnouncement'/>

    <!-- 主内容区域 --> 
    <main class="main-content flex-grow">
      <router-view />
    </main>
    <Footer :systemInfo="systemInfo"></Footer>
    <div class="fixed-btn fixed right-6 bottom-6 flex flex-col gap-3 z-50">
      <div class=""  v-if="systemInfo.distribution_enabled == 1" >
        <button @click="toSharePage" class="flex flex-col items-center justify-center w-10 py-2 rounded-full bg-orange-500 hover:bg-orange-600 text-white shadow-lg group relative text-xxs" title="推广有礼">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="mb-1" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
            <path d="M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"></path>
          </svg>
          <span class="text-[10px] font-medium leading-tight">推</span>
          <span class="text-[10px] font-medium leading-tight">广</span>
          <span class="text-[10px] font-medium leading-tight">有</span>
          <span class="text-[10px] font-medium leading-tight">礼</span>
        </button>
      </div>
      <div class="pulse-effect w-10 h-10 rounded-full" v-if="customerLinks.group_link">
        <div class="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center cursor-pointer" @click="handleChat('group')">
          <i class="iconfont icon-qun text-white" style="font-size:18px"></i>
        </div>
      </div>
      <div class="pulse-effect w-10 h-10 rounded-full" v-if="customerLinks.online_service_link">
        <div class="w-10 h-10 bg-primary-color rounded-full flex items-center justify-center cursor-pointer" @click="handleChat('online')">
          <i class="iconfont icon-kefu text-white text-2xl" style="font-size:28px"></i>
        </div>
      </div>
      <div class="w-10 h-10 rounded-full" v-if="customerLinks.tg_service_link">
        <div class="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer" @click="handleChat('tg')">
          <i class="iconfont icon-xiaofeiji text-white text-2xl"></i>
        </div>
      </div>
      <div class="w-10 h-10 rounded-full">
        <div class="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center cursor-pointer" 
            :class="{ 'hidden': !showBackToTop }"
            @click="scrollToTop">
          <i class="iconfont icon-arrow-up text-white text-2xl"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import pcNav from "@/components/pcNav.vue";
import mobileNav from "@/components/mobileNav.vue";
import Footer from "@/components/footer.vue"
import { ref, onMounted, onUnmounted, watch } from "vue";
import { userApi,protocolApi } from '@/api'
import emitter from '@/utils/eventBus';
import util from '@/utils/util'
import { useRoute, useRouter} from 'vue-router'
// import axios from 'axios';
// import {BASE_URL} from '@/utils/request'
// 管理移动端状态
const isMobile = ref(false);
const systemInfo = ref({});
//公告相关
//是否显示
const announcement = ref({});
const announcementSetOut = ref(null);
const route = useRoute()
const router = useRouter()
const closeAnnouncement = ()=>{
  sessionStorage.setItem('announcementId',announcement.value.id);
  announcement.value.show = false
  sessionStorage.setItem('announcementShow',announcement.value.show);
  localStorage.setItem('announcementShow',announcement.value.show);  
  emitter.emit('announcementShowChange');
}

// 检查设备屏幕宽度
const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 768;
};

const showBackToTop = ref(false);

const handleScroll = () => {
  showBackToTop.value = window.scrollY > 300;
};
const handleChat = (type) => {
  if(type === 'online'){
    window.open(customerLinks.value.online_service_link);
  }else if(type === 'tg'){
    window.open(customerLinks.value.tg_service_link);
  }else if(type === 'group'){
    window.open(customerLinks.value.group_link);
  }
};
const customerLinks = ref({});
const getCustomerLinks = async () => {
  const res = await userApi.getCustomerLinks();
  if(res.code === 1){
    customerLinks.value = res.data.customer_links;
    localStorage.setItem('customerLinks', JSON.stringify(res.data.customer_links));
  }else{
    console.log(res.msg);
  }
  
};
const getAnnouncement = async () => { 
  const res = await protocolApi.getAnnouncement();  
  if(res.code == 1){
    if(!res.data || JSON.stringify(res.data) == '{}'){
      announcement.value.show = false
    }else{
      announcement.value.title=res.data.title
      announcement.value.content = res.data.content
      announcement.value.token = res.data.token
      announcement.value.publish_time = res.data.publish_time
      announcement.value.id = res.data.id
      let id = sessionStorage.getItem('announcementId');
      // let id = localStorage.getItem('announcementId');
      if(id == announcement.value.id){
        announcement.value.show = false
      }else{
        announcement.value.show = true
      }      
    }    
    sessionStorage.setItem('announcementShow',announcement.value.show);
    localStorage.setItem('announcementShow',announcement.value.show);    
    emitter.emit('announcementShowChange');
  }
};
//获取用户信息并保存 用于刷新个人信息
const getUserInfo = () => {
    userApi.getUserInfo().then(res => {
        localStorage.setItem('allUserInfo', JSON.stringify(res.data));
        emitter.emit('loginStatusChange');
    });
}
//跳转至返利中心
const toSharePage = ()=>{  
  const token = localStorage.getItem('token');
  if(token){
    router.push('/personal/rebateCenter')
  }else{
    router.push('/share_not_login')
  }
  
}
onMounted(async() => {

  if(localStorage.getItem("token")){
    getUserInfo();
  }
  //公告相关
  
  localStorage.setItem('announcementShow',announcement.value.show);  
  emitter.emit('announcementShowChange');
  getAnnouncement()
  announcementSetOut.value = setInterval(()=>{
    getAnnouncement()
  },30000)

  getCustomerLinks()
  checkIsMobile();
  window.addEventListener("resize", checkIsMobile);
  window.addEventListener("scroll", handleScroll);
    try {
      // 调用后端接口获取网页标题和图标
      const res = await protocolApi.getSystemInfo();
      systemInfo.value= res.data;
      localStorage.setItem('systemInfo', JSON.stringify(systemInfo.value));
      // 动态设置网页标题
      document.title = systemInfo.value.system_name;
      // 动态设置网页图标
    } catch (error) {
      console.error('获取网页标题和图标失败:', error);
    }
});

onUnmounted(() => {
  window.removeEventListener("resize", checkIsMobile);
  window.removeEventListener("scroll", handleScroll);
  clearInterval(announcementSetOut.value)
});
watch(
  () => route.query,
  (newQuery) => {
    const channel = newQuery.channel
    const share_link = newQuery.ref
    if (channel) {
      try { 
        util.setCookie('channel', channel); 
        localStorage.setItem('channel', channel); 
      } catch(e){}
    }
    if(share_link){      
      sessionStorage.setItem('share_link',share_link);
    }
  },
  { immediate: true } // 页面首次加载也触发一次
)

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};


//设置网页图标
// const setFavicon = (iconUrl) => {
//   console.log(iconUrl,'iconUrl')
//   let link = document.querySelector("link[rel~='icon']");
//   if (!link) {
//     link = document.createElement('link');
//     link.rel = 'icon';
//     document.head.appendChild(link);
//   }
//   link.href = iconUrl;
// };
    
</script>
<style lang="scss">
.navbar-content {
  max-width: 72rem;
  padding: 0 1.5rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
}
.navbar-brand {
  .logo-img {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.5rem;
  }
  .logo-text {
    color: #fff;
    font-size: 1.125rem;
    font-weight: 600;
  }
}
.fixed-btn{
 
}
.pulse-effect{
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 150, 136, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(0, 150, 136, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 150, 136, 0);
  }
}
</style>
